import { subscribe } from 'pubsub-js';

import { MessagingServiceEvent } from './messaging-service-plugin';
import { AuthEvent } from './auth-plugin';

let started;

/**
 * setIsMessagingServiceStarted
 * @param {boolean} messagingServiceStarted
 * @returns
 */
export const setIsMessagingServiceStarted = (messagingServiceStarted) =>
  (started = messagingServiceStarted);

/**
 * To advoid missing Genesys event, provides a function to do early subscription
 * on Genesys messaging service event
 */
export const earlySubsribeToMessagingServiceEvents = () => {
  subscribe(MessagingServiceEvent.Started, () => {
    setIsMessagingServiceStarted(true);
  });

  subscribe(MessagingServiceEvent.Restored, () => {
    setIsMessagingServiceStarted(true);
  });

  [
    MessagingServiceEvent.Error,
    MessagingServiceEvent.ConversationCleared,
    MessagingServiceEvent.RestoreFailed,
    /*
     * For re-authentication
     */
    AuthEvent.Authenticating,
  ].forEach((notStartedEvent) => {
    subscribe(notStartedEvent, () => {
      setIsMessagingServiceStarted(false);
    });
  });
};

export const waitForMessagingServiceStarted = (timeout = 15000) => {
  if (started) {
    return Promise.resolve();
  }

  return new Promise((resolve, reject) => {
    const interval = 1000;

    const intervalCheck = (remainedTime) => {
      const timeoutHandle = setTimeout(() => {
        const newRemainedTime = remainedTime - interval;

        clearTimeout(timeoutHandle);

        if (started) {
          resolve();
        } else if (newRemainedTime > 0) {
          intervalCheck(newRemainedTime);
        } else {
          reject();
        }
      }, interval);
    };

    intervalCheck(timeout);
  });
};
